export const getApiUrl = (): string => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    
    // Automatically point to backend/api on the same server to support XAMPP local network IP access
    const basePath = pathname.includes('/kaynin/') ? '/kaynin' : '';
    
    // Force routing to XAMPP (port 80) if we are on any local development server (Vite, Live Server, etc.)
    const hostname = window.location.hostname;
    if ((hostname === "localhost" || hostname === "127.0.0.1") && window.location.port !== "" && window.location.port !== "80") {
      // Connect to the real Hostinger backend via Vite proxy so XAMPP isn't required locally
      return `/backend/api`;
    }
    
    return `${origin}${basePath}/backend/api`;
  }
  
  return "http://localhost/kaynin/backend/api";
};

// Global Fetch Interceptor to inject the Auth Token
if (typeof window !== "undefined") {
  const originalFetch = window.fetch;
  window.fetch = async function(input: RequestInfo | URL, init?: RequestInit) {
    const url = typeof input === "string" ? input : (input instanceof Request ? input.url : input.toString());
    
    // Check if it's an API call to our backend
    if (url.includes("/backend/api/")) {
      const token = localStorage.getItem('kaynin_auth_token');
      if (token) {
        init = init || {};
        init.headers = {
          ...init.headers,
          'Authorization': `Bearer ${token}`
        };
      }
    }
    
    return originalFetch.call(this, input, init);
  };
}
